var FixEquityInEtds, Migration, W, fetchOldEtdVotingDoc, mediator, migrationName, removeEquityConsensus, templateDataPath,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

mediator = require('mediator');

Migration = require('./migration');

W = require('when');

migrationName = 'fix_equity_in_etds';

templateDataPath = ['templateData', 'assessment', 'criteria', 'equity', 'selectedOptionConsensus'];

removeEquityConsensus = function(isOldVoting, doc) {
  var docImm, isTemplateDataSet;
  docImm = Immutable.fromJS(doc);
  isTemplateDataSet = !_.isEmpty(docImm.getIn(templateDataPath));
  if (isOldVoting && isTemplateDataSet) {
    return doc;
  } else {
    return docImm.deleteIn(templateDataPath).toJS();
  }
};

fetchOldEtdVotingDoc = function(adapter, projectId) {
  return adapter.fetch(projectId, 'etd-voting-preferences')["catch"](function(err) {
    if (err.status !== 404) {
      throw err;
    }
    return null;
  });
};

module.exports = FixEquityInEtds = (function(_super) {
  __extends(FixEquityInEtds, _super);

  function FixEquityInEtds() {
    FixEquityInEtds.__super__.constructor.call(this, false);
  }

  FixEquityInEtds.prototype.up = function(project, colls) {
    var adapter, docIds, projectId;
    FixEquityInEtds.__super__.up.apply(this, arguments);
    projectId = project.id;
    adapter = mediator.services.storePersistenceAdapter;
    docIds = colls.questions.reduce(function(docIds, q) {
      return docIds.concat(q.get('recommendationIds')).concat(q.get('recommendationAdolopmentIds', []));
    }, []);
    docIds = docIds.concat(['etd-tx-template', 'etd-dx-template', 'etd-overarchingTx-template', 'etd-overarchingDx-template']);
    return W.all([adapter.fetch(projectId, _.compact(_.uniq(docIds))), fetchOldEtdVotingDoc(adapter, projectId)]).then(function(_arg) {
      var oldVotingDoc, rows, templateDocs, _ref;
      (_ref = _arg[0], rows = _ref.rows), oldVotingDoc = _arg[1];
      templateDocs = _.chain(rows).filter(function(rows) {
        return rows.doc != null;
      }).pluck('doc').value();
      return {
        templateDocs: templateDocs,
        oldVotingDoc: oldVotingDoc
      };
    }).then(function(_arg) {
      var oldVotingDoc, templateDocs, updatedDocs;
      templateDocs = _arg.templateDocs, oldVotingDoc = _arg.oldVotingDoc;
      if (_.isEmpty(templateDocs)) {
        return W.resolve();
      }
      updatedDocs = _.map(templateDocs, function(doc) {
        doc = removeEquityConsensus(oldVotingDoc !== null, doc);
        return _.extend(doc, {
          rev_author: "project_migration/" + migrationName
        });
      });
      return adapter.bulkDocs(projectId, updatedDocs);
    });
  };

  return FixEquityInEtds;

})(Migration);
